import { maskProviderTags, type MaskedProviderTags } from "./provider-tag-mask";

/**
 * Klaviyo-proprietary Django tags, masked for the same reason as Braze's — see
 * `provider-tag-mask.ts`. Klaviyo resolves these at send time; our parser only
 * needs to stop treating them as errors.
 */
export const DJANGO_PROVIDER_TAG_NAMES = new Set([
  "web_view",
  "unsubscribe",
  "manage_preferences",
]);

export function maskDjangoProviderTags(
  template: string,
  tagNames: ReadonlySet<string> = DJANGO_PROVIDER_TAG_NAMES,
): MaskedProviderTags {
  return maskProviderTags({
    template,
    tagNames,
    placeholderPrefix: "__HT_DJANGO_TAG__",
  });
}
